import { onBeforeUnmount, ref } from 'vue';

export async function writeToClipboard(text) {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (error) {
            // Fall back to the legacy path below.
        }
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length);

    let copiedText = false;

    try {
        copiedText = document.execCommand('copy');
    } catch (error) {
        copiedText = false;
    }

    document.body.removeChild(textArea);

    return copiedText;
}

export function useTimedFlag(duration = 1800) {
    const flag = ref(false);
    let timeoutId;

    function clearTimer() {
        if (timeoutId) {
            globalThis.clearTimeout(timeoutId);
            timeoutId = undefined;
        }
    }

    function trigger() {
        flag.value = true;
        clearTimer();
        timeoutId = globalThis.setTimeout(() => {
            flag.value = false;
            timeoutId = undefined;
        }, duration);
    }

    function reset() {
        flag.value = false;
        clearTimer();
    }

    onBeforeUnmount(() => {
        clearTimer();
    });

    return {
        flag,
        trigger,
        reset,
    };
}
